import { ProductUnit } from '../../../../../../types/ProductUnit';
import { Avatar } from '../../../../../cdl/Avatar/Avatar';
import { Tag } from '../../../../../cdl/Tag/Tag';
import { Text } from '../../../../../cdl/Text/Text';
import { SupplierInfoDatasheet } from '../../../../../common/CoreDataPopup/SupplierInfoPopup';
import { calculateVolumeWithPrices } from '../../../../../common/helpers/calculate.utilities';
import { formatTotalPrice } from '../../../../../common/helpers/formatTotal.helper';
import { translate } from '../../../../../common/helpers/translate.helper';
import { Characters } from '../../../../../common/helpers/unicode.helper';
import { InfoPopover } from '../../../../../common/InfoPopover/InfoPopover';
import { Box } from '../../../../../common/ui/Box';
import { OfferLabelList } from '../../../components/OfferCard/components/OfferLabelList';
import { OfferSupplierAndTotalsGrid } from '../../../components/OfferCard/components/OfferSupplierAndTotalsGrid';
import { useOfferCardContext } from '../../../components/OfferCard/hooks/useOfferCardContext';
import { PriceVolumeSubline } from '../../PriceVolumeSubline';

interface OfferSupplierAndTotalsProps {
    isBestLiterPrice?: boolean;
}

export const OfferSupplierAndTotals = ({ isBestLiterPrice }: OfferSupplierAndTotalsProps) => {
    const { offer } = useOfferCardContext();
    const isDefaultSupplier = offer.supplierId === offer.vessel?.defaultSupplierId;

    return (
        <OfferSupplierAndTotalsGrid>
            <Avatar name={offer.supplier.name} imageUrl={offer.supplier.supplierGroup.logo?.url} />
            <Box display="flex" flexDirection="column">
                <Box display="flex" alignItems="center" gap="4px">
                    <Text variant="subtitle1" style={{ whiteSpace: 'nowrap' }}>
                        {offer.supplier.name}
                    </Text>
                    {offer.isSpot() ? (
                        <InfoPopover align="start" width="360px">
                            <Box padding={16} onClick={(event) => event.stopPropagation()}>
                                <SupplierInfoDatasheet supplier={offer.supplier} />
                            </Box>
                        </InfoPopover>
                    ) : null}
                    {isDefaultSupplier ? <Tag variant="default">{translate('labelList.default')}</Tag> : null}
                </Box>
                <OfferLabelList />
            </Box>

            <Box display="flex" flexDirection="column" alignItems="end">
                <Box display="flex" justifyContent="end" alignItems={isBestLiterPrice ? 'center' : 'end'} columnGap={8}>
                    {offer.hasValidProducts() && isBestLiterPrice ? (
                        <Tag variant="positive">{translate('order.detail.offerCard.bestLiterPrice')}</Tag>
                    ) : null}

                    <Text variant="subtitle1">
                        {offer.hasValidProducts() ? formatTotalPrice(offer.total) : Characters.EN_DASH}
                    </Text>
                </Box>

                {offer.hasValidProducts() && offer.ppl ? (
                    <PriceVolumeSubline
                        price={offer.ppl}
                        volume={calculateVolumeWithPrices(offer.items)}
                        unit={ProductUnit.L}
                    />
                ) : null}
            </Box>
        </OfferSupplierAndTotalsGrid>
    );
};
